<template>
  <div class="help padding_top">
    <div class="flex userPh ">
      <p><strong>第一步：</strong>打开【微信APP】，在首页点击<span class="orange">【搜索框】</span></p>
      <p><strong>第二步：</strong>在搜索框中，输入【心理亦笙】，查看结果<span class="orange">【绑定】</span></p>
      <p><strong>第三步：</strong>在选择小程序项，点击<span class="orange">【心理亦笙】</span>即可进入小程序</p>
    </div>
    <img src="../../assets/img/collection_a.png" alt="">
    <div class="flex userPh ">
      <p><strong>第四步：</strong>在【心理亦笙】小程序中，点击右上角<span class="orange">【…】</span>按钮</p>
      <p><strong>第五步：</strong>在下方点击<span class="orange">【添加到我的小程序】</span>，即可收藏成功</p>
      <p></p>
    </div>
    <img src="../../assets/img/collection_b.png" alt="" width="610">
    <p><strong>【查看收藏小程序】</strong></p>
    <div class="flex userPh ">
      <p><strong>第一步：</strong>打开【微信APP】，在首页下拉展示【最近】</p>
      <p><strong>第二步：</strong>在【我的小程序】即可看到【心理亦笙】小程序</p>
      <p></p>
    </div>
    <img src="../../assets/img/collection_c.png" alt="" >
  </div>
</template>

<script>
export default {
  name: "collection",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/help";
</style>
